var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatrol1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 56,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 629,
    y: 540,
    width: 60,
    height: 56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6350.05,
    y: -6350.09,
    width: 393720,
    height: 368319
  })), /*#__PURE__*/React.createElement("image", {
    width: 70,
    height: 66,
    xlinkHref: "data:image/jpeg;base64,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",
    preserveAspectRatio: "none",
    id: "img2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 377172,
    height: 355619
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-629 -540)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    transform: "matrix(0.000157472 0 0 0.000157472 629 540)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    transform: "matrix(1.0102 0 0 1 0.0245162 -0.00478065)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img2",
    transform: "scale(5388.17 5388.17)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatrol1);
export default __webpack_public_path__ + "static/media/Patrol1.d8d08969e4ab417b3571f959a262fd5d.svg";
export { ForwardRef as ReactComponent };